import Transaction from '../../models/transactions/transaction.model';

const storeContent = utils.generateStore({
  Transaction,
  transactions: [],
  idTransactions: [],
  dashTransactions: [],
});

export default {
  state: {
    ...storeContent.state,
  },
  getters: {
    ...storeContent.getters,
  },
  mutations: {
    ...storeContent.mutations,
  },
  actions: {
    async queryTransactions(ctx, payload) {
      try {
        ctx.commit('loading', true);
        const data = payload.ref.formData_;

        if (await payload.ref.isValid()) {
          const from = moment(`${data.duration[0]} 00:00`, 'DD-MM-YYYY HH:mm').valueOf();
          const to = moment(`${data.duration[1]} 23:59`, 'DD-MM-YYYY HH:mm').valueOf();

          const res = await api.fetchEndpointSecure({
            resource: 'registration',
            action: 'fetch:transactionsByDate',
            data: {
              status: data.status,
              from,
              to,
            },
            meta_data: {},
          });
          ctx.commit('transactions', res.result.transactions);
          console.log(from, to);
        }

        ctx.commit('loading', false);
      } catch (err) {
        ctx.commit('loading', false);
        throw err;
      }
    },
    async queryTransactionsByID(ctx, payload) {
      try {
        ctx.commit('loading', true);
        const data = payload.ref.formData_;

        if (await payload.ref.isValid()) {
          const res = await api.fetchEndpointSecure({
            resource: 'registration',
            action: 'fetch:transactionsByReceiptNumber',
            data: {
              receipt_number: data.tranRef,
            },
            meta_data: {},
          });
          ctx.commit('idTransactions', res.result.transaction);
          console.log(from, to);
        }

        ctx.commit('loading', false);
      } catch (err) {
        ctx.commit('loading', false);
        throw err;
      }
    },
    async fetchTransactionsDashboard(ctx, payload) {
      try {
        // let res = await api.fetchEndpointSecure({
        //    resource: "registration",
        //    action: "fetch:transactionsByReceiptNumber",
        //    data: {
        //       receipt_number: data.tranRef,
        //    },
        //    meta_data: {}
        // })
        // ctx.commit('dashTransactions', res.result.transaction)
        EventBus.$emit('loader:show', false);
      } catch (err) {
        ctx.commit('loading', false);
        throw err;
      }
    },
  },
};
